import './styles/general.scss';
import "bootstrap";
import {hideNavOnClick, hideNavOnScroll} from "./scripts/navbar";
import {hideMobileHomePortfolio, initPortfolio} from "./scripts/portfolio";
import {initActiveLabels, initCircleProgress, initMouseMove} from "./scripts/sidebar";
import {initCountUp} from "./scripts/countup";
import {initRive} from "./scripts/rive";
import {initLottie} from "./scripts/lottie";
import {dealWithFiltering} from "./scripts/filtering";
import {initMoreRows} from "./scripts/collapse";
import {initKinkezinsCircle} from "./scripts/kinkezins-circle";
import {initLazyVideos} from "./scripts/lazy-video";



initLazyVideos()
dealWithFiltering()
initPortfolio()
initActiveLabels()
hideMobileHomePortfolio()

window.onload = () => {
    hideNavOnClick()
    initCircleProgress()
    initCountUp()
    initMouseMove()
    initRive()
    initLottie()
    initMoreRows()
    initKinkezinsCircle()
}

window.addEventListener('scroll', () => {
    hideNavOnScroll()
})

window.onresize = () => {
}
